import React, { useState, useEffect, useMemo, useRef } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { Card, CardBody, Row, Col, CardFooter, CardTitle } from "reactstrap";
import themeDetails from "../../getThemeDetails";
import { useHistory } from "react-router-dom";
import Content from "../../layouts/Dashboard/Content";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getMappedList } from "../../redux/actions/getMappedListAction";
import { getWalletAcRequired } from "../../../src/redux/actions/walletAcRequiredAction";
import { getDefaultCurrencyList } from "../../../src/redux/actions/adminCurrencyListAction";
import sidebarRoutes from "../../routes/sidebarRoutes/sidebarRoutes";
import { getSidebar } from "../../redux/actions/sidebarAction";
import { getMappedListForAdmins } from "../../redux/actions/getMappedListFoAdminAction";
import {
	resetGetOperationList,
	getOperationList,
} from "../../redux/actions/getOperationListAction";
import {
	getRegenerateToken,
	resetRegenerateToken,
} from "../../redux/actions/regenerateTokenAction";
import { getModulesForPartner } from "../../redux/actions/modulesForPartnerAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails"

const adminArr = [
	{
		service: "account",
		name: "Account Management",
		icon: "my-accounts",
		logoName: "MyAccounts",
		flag: "ACCOUNT MANAGEMENT",
		description: "Manage profiles, bank accounts, cards etc. of users."
	},
	{
		service: "settings",
		name: "Settings",
		icon: "Settings",
		logoName: "Settings",
		flag: "SETTINGS",
		description: "Manage account, wallet and other flag settings handled."
	},
	{
		service: "kycmanagement",
		name: "KYC Management",
		icon: "Wallet",
		logoName: "kyc management",
		flag: "KYC",
		description: "Manage KYC configuration and reports of the users."
	},
	{
		service: "prepaidcard",
		name: "Wallet Management",
		icon: "MyWallets",
		logoName: "MyWallets",
		flag: "WALLET MANAGEMENT",
		description:
			"Manage Wallet transactions like send, receive, top-up, withdraw."
	},
	{
		service: "voucher",
		name: "Voucher Management",
		icon: "voucher management",
		logoName: "voucher management",
		flag: "VOUCHER MANAGEMENT",
		description: "Manage Vouchers which are purchased and redeem by the users."
	},
	{
		service: "invoiceManagement",
		name: "Invoice Management",
		icon: "invoice",
		logoName: "invoice1",
		flag: "INVOICE MANAGEMENT",
		description:
			"Manage, generate, remind, cancel and regenerate invoices of the users."
	},
	{
		service: "marketplace",
		name: "Currency Management",
		icon: "Currency",
		logoName: "Currency",
		flag: "CURRENCY MANAGEMENT",
		description: "Manage currencies which are assigned to the users."
	},

	{
		service: "limitmanagement",
		name: "Limit Management",
		icon: "limit management",
		logoName: "limit management",
		flag: "LIMIT MANAGEMENT",
		description:
			"Manage transaction related limits like Load limit and Withdraw limit.",
	},

	{
		service: "feeManagement",
		name: "Fee Management",
		icon: "fee",
		logoName: "FEE",
		flag: "FEE MANAGEMENT",
		description: "Manage fees which is applied on the transactions.",
	},
	{
		service: "wallet",
		name: "Fraud & Risk Management",
		icon: "fraud and risk management",
		logoName: "fraud and risk management",
		flag: "RISK RULE MANAGEMENT",
		description: "Manage transactions related fraud and risk rules.",
	},

	{
		service: "settlementmanagement",
		name: "Settlement Management",
		icon: "market-place",
		logoName: "settlement management2",
		flag: "SETTLEMENT MANAGEMENT",
		description:
			"Manage settled transactions with the bank and generate the reports."
	},

	{
		service: "gatewayManagement",
		name: "Transaction Management",
		icon: "TransactionHistory",
		logoName: "TransactionHistory",
		flag: "TRANSACTION MANAGEMENT",
		description:
			"Manage gateway or bank related transactions done by the users.",
	},
	{
		service: "GatewayManagement",
		name: "Gateway Management",
		icon: "Gateway Management",
		logoName: "MyBank",
		flag: "GATEWAY MANAGEMENT",
		description: "Manage gateway related details and merchant mapping.",
	},
	{
		service: "userManagement",
		name: "User Management",
		icon: "User Management",
		logoName: "userManagement",
		flag: "USER MANAGEMENT",
		description: "Create, edit, view, delete and manage sub-dealers",
	},

	{
		service: "cashLifting",
		name: "Cash Lifting",
		icon: "User Management",
		logoName: "cash_Lifting",
		flag: "CASH LIFTING",
		description: "Manage Top-up for dealer, request is initiated.",
	},
	{
		service: "withdrawEMoney",
		name: "Withdraw E Money",
		icon: "User Management",
		logoName: "Withdraw_E_Money",
		flag: "WITHDRAW E MONEY",
		description: "Manage Top-up for dealer, request is initiated.",
	},
	{
		service: "agentDealerMapping",
		name: "Agent Dealer Mapping",
		icon: "User Management",
		logoName: "AgentDealerMap",
		flag: "CASH LIFTING",
		description: "Manage Top-up for dealer, request is initiated.",
	},
	// {
	// 	service: "userManagement",
	// 	name: "User Management",
	// 	icon: "User Management",
	// 	logoName: "MyBank",
	// 	flag: "walletRequired",
	// 	description: "Manage gateway related details and merchant mapping.",
	// },
];

const supAdminArr = [
	{
		service: "walletOwnerManagement",
		name: "Owner Management",
		icon: "my-accounts",
		logoName: "MyAccounts",
		flag: "Owner Management",
		description: "Manage and Create wallet owner or partner profiles.",
	},
	// {
	// 	service: "adminGatewayManagement",
	// 	name: "Gateway Management",
	// 	icon: "Wallet",
	// 	logoName: "MyBank",
	// 	flag: "walletRequired",
	// 	description:
	// 		"Wallet services to send money, receive money, top-up, widthdrw etc."
	// },
	{
		service: "adminFraudRiskManagement",
		name: "Fraud and Risk Management",
		//name: "Fraud & Risk Management",
		icon: "Voucher",
		logoName: "fraud and risk management",
		// flag: "voucherRequired",
		description: "Manage and Set transactions related fraud and risk rules for wallet owners",
	},
	{
		service: "adminCurrencyManagement",
		name: "Currency Management",
		icon: "market-place",
		logoName: "Currency",
		flag: "voucherRequired",
		description: "Manage currencies which are assigned to the owners.",
	},
	{
		service: "adminWalletManagement",
		name: "Wallet Management",
		icon: "prepaid-card",
		logoName: "MyWallets",
		flag: "voucherRequired",
		description: "Manage Wallet transactions like send, receive, top-up and prepaid.",
	},
	{
		service: "adminKycManagement",
		name: "KYC Management",
		icon: "my-accounts",
		logoName: "kyc management",
		flag: "voucherRequired",
		description: "Manage KYC configuration and reports of the users.",
	},
	{
		service: "adminFeeMaster",
		name: "Fee Master",
		icon: "fee master",
		logoName: "fee master",
		flag: "walletRequired",
		description: "Manage and add fees which is applied on the transactions.",
	},
	{
		service: "adminSetting",
		name: "Settings",
		icon: "Wallet",
		logoName: "Settings",
		flag: "walletRequired",
		description: "Manage account, wallet and other flag settings handled.",
	},
	{
		service: "adminTransactionManagement",
		name: "Transaction Management",
		icon: "prepaid-card",
		logoName: "MyWallets",
		flag: "voucherRequired",
		description: "Manage Wallet transactions like send, receive, top-up and prepaid.",
	},
	{
		service: "AdminGatewayManagement",
		name: "Gateway Management",
		icon: "Gateway Management",
		logoName: "MyBank",
		flag: "voucherRequired",
		description:
			"Manage gateway related details and merchant mapping.",
	},
	{
		service: "userManagementAdmin",
		name: "User Management",
		icon: "User Management",
		logoName: "userManagement",
		flag: "voucherRequired",
		description: "Create, edit, view, delete and manage sub-dealers",
	},
	// {
	// 	service: "adminUserManagementData",
	// 	name: "Tran User Management",
	// 	icon: "prepaid-card",
	// 	logoName: "MyWallets",
	// 	flag: "voucherRequired",
	// 	description: "Manage Wallet transactions like send, receive, top-up and prepaid.",
	// },
];

const dealer = [
	{
		service: "dealerProfile",
		name: " Profile",
		icon: "my-accounts",
		logoName: 'UserProfile',
		flag: "voucherRequired",
		description: "Manage and view profile details for Dealer.",

	},

	{
		service: "dealerDSRManagement",
		name: "DSR Management",
		icon: "my-accounts",
		logoName: "management",
		flag: "voucherRequired",
		description: "Manage DSR details, DSR transactions and limits.",

	},

	{
		service: "dealerCashLifting",
		name: "Cash Lifting",
		icon: "my-accounts",
		logoName: "cash_Lifting",
		flag: "voucherRequired",
		description: "Manage Top-up for dealer, request is initiated.",

	},

	{
		service: "dealerWithdrawEMoney",
		name: "Withdraw E-Money",
		icon: "my-accounts",
		logoName: "Withdraw_E_Money",
		flag: "voucherRequired",
		description: "Manxage Withdraw for dealer, request is initiated",

	},

	{
		service: "dealerPendingRequest",
		name: "Pending Request",
		icon: "my-accounts",
		logoName: "Pending_Req",
		flag: "voucherRequired",
		description: "Money deducted from dealer added to agent/Merchant/Combo.",

	},

	{
		service: "dealerWalletManagement",
		name: "Wallet Management",
		icon: "my-accounts",
		logoName: "WalletManagement",
		flag: "voucherRequired",
		description: "Manage wallet transaction like CashIn, CashOut.",

	},

	{
		service: "dealerUserManagement",
		name: "User Management",
		icon: "my-accounts",
		logoName: "userManagement",
		flag: "voucherRequired",
		description: "Create, edit, view, delete and manage sub-dealers.",

	},
	{
		service: "dealerAgentMaster",
		name: " Agent Master",
		icon: "my-accounts",
		logoName: 'customer master',
		flag: "voucherRequired",
		description: "Add DSR, manage mappings for DSR and upload agent.",

	}


]

const bank = [

	{
		service: "bankModulebankmaster",
		name: "Bank Master",
		icon: "Bank Baster",
		logoName: "MyBank",
		flag: "voucherRequired",
		description: "Manage banks",

	},

	{
		service: "bankModulecashLifting",
		name: "Cash Lifting",
		icon: "Cash Lifting",
		logoName: "cash_Lifting",
		flag: "voucherRequired",
		description: "Manage cash lifting",

	},

	{
		service: "bankWithdrawEMoney",
		name: "Withdraw E-Money",
		icon: "Withdraw E-Money",
		logoName: "Withdraw_E_Money",
		flag: "voucherRequired",
		description: "Withdraw and manage e-money",

	},

	{
		service: "bankUserManagement",
		name: "User Management",
		icon: "User Management",
		logoName: "userManagement",
		flag: "voucherRequired",
		description: "Add and manage users",

	},

]

function MainDashboard() {
	const history = useHistory();
	const dispatch = useDispatch();
	let r = sidebarRoutes();

	const modulesForPartnerRes = useSelector(
		({ modulesForPartner }) => modulesForPartner
	);



	const [a, seta] = useState(false);
	const [service, setservice] = useState("");
	const [servicename, setservicename] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [getMapStatus, setGetMapStatus] = useState("")
	const [getMapStatusAdmin, setGetMapStatusAdmin] = useState("")

	const [getMapArr, setGetMapArr] = useState([])
	const [getMapArrAdmin, setGetMapArrAdmin] = useState([])
	const [filteredModules, setFilteredModules] = useState([]);

	const dashboardInitialized = useRef(false); // ← ADD THIS

	const partnerloginUser = useSelector(({ login }) => login);
	var authTokens = partnerloginUser.data.AuthToken;
	sessionStorage.setItem("walletOwnerId", partnerloginUser.data.partnerId);

	const login = useSelector(({ login }) => login);

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const Theme = useSelector((state) => state.theme.theme);


	sessionStorage.setItem("walletOwnerId", regenerateTokenRes.data.partnerId);
	const getMappedListRes = useSelector(
		({ getMappedList }) => getMappedList
	);

	const getMappedListForAdminRes = useSelector(
		({ getMappedListsForadmins }) => getMappedListsForadmins
	)
	console.log("getttSubmod", getMappedListForAdminRes)
	var authToken = regenerateTokenRes.data.AuthToken;


	// Roles

	const walletAcRequired = useSelector(
		({ walletAcRequired }) => walletAcRequired
	);
	const partnerId = regenerateTokenRes.data.partnerId; // Get partnerId
	// const filteredServices =
	// 	partnerId === "2"
	// 		? supAdminArr
	// 		: supAdminArr.filter((service) =>
	// 			getMapArrAdmin.includes(service.name)
	// 		);
	const filteredServices = useMemo(() => {
		if (login.data.partnerId === "2" || login.data.partnerId === "105" || login.data.partnerId === "200") {
			return supAdminArr;
		} else {
			return supAdminArr.filter(service =>
				getMapArrAdmin.includes(service.name)
			);
		}
	}, [login.data.partnerId, getMapArrAdmin]);

	const WalletAcRequiredFunc = () => {
		const WalletAcRequired = {
			authentication: {
				// partnerId: regenerateTokenRes.data.partnerId,
				partnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId
				// partnerId: "2",

			},
		};

		return dispatch(getWalletAcRequired(WalletAcRequired, authToken));
	};

	// useEffect(() => {
	// 	WalletAcRequiredFunc();
	// }, []);

	// Currency

	// useEffect(() => {
	// 	regenerateToken();
	// }, []);

	// const regenerateToken = () => {
	// 	console.log("<<<<<<<<<<<<<<<<<<<<<<<<<???????????????????????????????? Main dashboard")
	// 	const regenerateTokenReq = {
	// 		authentication: {
	// 			partnerId: partnerIds,
	// 		},
	// 		authToken: authTokens,
	// 	};

	// 	return dispatch(getRegenerateToken(regenerateTokenReq));
	// };

	const getMappedListReq = () => {
		if (login.data.Role.toLowerCase() === "owner") {
			setGetMapStatus(true)
			setIsLoading(true);
			let req = {
				ownerMasterRequestVO: {
					ownerID: regenerateTokenRes.data.partnerId
				}
			}
			dispatch(getMappedList(req, authToken))
		}
	}

	const getMappedListFunc = () => {
		if (getMapStatus) {
			if (getMappedListRes.data.status == "success") {
				if (getMappedListRes.data.moduleAllocationVO) {
					setGetMapArr(getMappedListRes.data.moduleAllocationVO.masterModuleMappingList)
					setIsLoading(false);
				}
			}
			if (getMappedListRes.data.status == "failed") {
				setGetMapArr(getMappedListRes.data)
				setIsLoading(false);
				if (
					getMappedListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getMappedListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		getMappedListFunc()
	}, [getMappedListRes.data.status])

	const getMappedListForAdminReq = () => {
		if (
			login.data.subRole === "SubAdmin" && login.data.Role.toLowerCase() === "admin") {

			setGetMapStatusAdmin(true)
			setIsLoading(true);
			let req = {
				ownerMasterRequestVO: {
					adminId: regenerateTokenRes.data.partnerId
				}
			}
			dispatch(getMappedListForAdmins(req, authToken))
		}
	}

	// const getMappedListForAdminsFunc = () => {
	// 	if (getMapStatusAdmin && getMappedListForAdminRes?.data) {
	// 		if (getMappedListForAdminRes.data.status === "success") {
	// 			if (getMappedListForAdminRes.data.moduleAllocationVO) {
	// 				setGetMapArrAdmin(getMappedListForAdminRes.data.moduleAllocationVO.masterModuleMappingList || []);
	// 				setIsLoading(false);
	// 			}
	// 		} else if (getMappedListForAdminRes.data.status === "failed") {
	// 			setGetMapArrAdmin([]);
	// 			setIsLoading(false);
	// 			if (getMappedListForAdminRes.data.description === "session out") {
	// 				SOLogout(dispatch, authToken, regenerateTokenRes?.data?.partnerId);
	// 			} else if (getMappedListForAdminRes.data.description === "Authorization failed") {
	// 				regenerateToken(dispatch, authToken, regenerateTokenRes?.data?.partnerId);
	// 			}
	// 		}
	// 	}
	// };
	// useEffect(() => {
	// 	if (getMappedListForAdminRes?.data?.status) {
	// 		getMappedListForAdminsFunc();
	// 	}
	// }, [getMappedListForAdminRes?.data?.status]);

	// useEffect(() => {
	// 	if (regenerateTokenRes?.data?.status === "success") {
	// 		getMappedListForAdminReq();
	// 	}
	// }, [regenerateTokenRes?.data?.status]);

	// const getMappedListForAdminsFunc = () => {
	// 	if (getMapStatusAdmin) {
	// 		if (getMappedListForAdminRes.data.status == "success") {
	// 			if (getMappedListForAdminRes.data.moduleAllocationVO) {
	// 				setGetMapArrAdmin(getMappedListForAdminRes.data.moduleAllocationVO.masterModuleMappingList)
	// 				setIsLoading(false);
	// 			}
	// 		}
	// 		if (getMappedListForAdminRes.data.status == "failed") {

	// 			setGetMapArrAdmin(getMappedListForAdminRes.data)
	// 			setIsLoading(false);
	// 			if (
	// 				getMappedListForAdminRes.data.description == "session out"
	// 			) {
	// 				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 			}
	// 			if (
	// 				getMappedListForAdminRes.data.description == "Authorization failed"
	// 			) {
	// 				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 			}
	// 		}
	// 	}
	// }
	const getMappedListForAdminsFunc = () => {
		if (getMapStatusAdmin) {
			if (getMappedListForAdminRes.data.status === "success") {
				if (getMappedListForAdminRes.data.moduleAllocationVO) {
					setGetMapArrAdmin(getMappedListForAdminRes.data.moduleAllocationVO.masterModuleMappingList);
					setIsLoading(false);
				}
			} else if (getMappedListForAdminRes.data.status === "failed") {
				setGetMapArrAdmin([]);
				setIsLoading(false);
				if (getMappedListForAdminRes.data.description === "session out") {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (getMappedListForAdminRes.data.description === "Authorization failed") {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};
	useEffect(() => {
		getMappedListForAdminsFunc()
	}, [getMappedListForAdminRes.data.status])
	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status === "success" && !getMapStatusAdmin) {
	// 		getMappedListForAdminReq();
	// 	}
	// }, [regenerateTokenRes.data.status, getMapStatusAdmin]);

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status === "success" && login.data.partnerID !== "2") {
	// 		getMappedListForAdminReq();
	// 	}
	// }, [regenerateTokenRes.data.status]);


	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		getMappedListReq()
	// 		// getMappedListForAdminReq()
	// 		DefaultCurrencyListFunc();
	// 		WalletAcRequiredFunc();
	// 		setGetOperationListStatusFunc();
	// 	}
	// }, [regenerateTokenRes.data.status]);

	// ✅ REPLACE both useEffects above with this single one:
	useEffect(() => {
		if (regenerateTokenRes.data.status !== "success") return;
		if (dashboardInitialized.current) return; // ← RUNS ONLY ONCE

		dashboardInitialized.current = true;

		getMappedListReq();
		getMappedListForAdminReq();
		DefaultCurrencyListFunc();
		WalletAcRequiredFunc();
		setGetOperationListStatusFunc();

		 // ✅ moved in here, using the same regenerated token, same gate
    dispatch(
        getModulesForPartner(
            {
                authentication: {
                    partnerId: 1,
                    sKey: "OZa6b6SNays37d+UVaWnfqJsuHI5W+i4SawctRtwy4A=",
                },
            },
            regenerateTokenRes.data.AuthToken,   // ✅ guaranteed populated at this point
            history
        )
    );

	}, [regenerateTokenRes.data.status]);



	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const DefaultCurrencyListFunc = () => {
		const DefaultCurrencyList = {
			loginDetails: {
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
				// walletOwnerId: login.data.subRole==="SUBOWNER" ? login.data.parentId:"",
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,

				// walletOwnerId: login.data.parentId,


				role: "",
			},

		};
		localStorage.setItem("subRole", login.data.subRole);
		//console.log("hi",login.data.subRole);
		return dispatch(getDefaultCurrencyList(DefaultCurrencyList, authToken));
	};

	const setGetOperationListStatusFunc = () => {
		const getOperationListReq = {
			loginDetails: {
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,

			},
		};

		return dispatch(getOperationList(getOperationListReq, authToken));
	};

	// useEffect(() => {
	//   setGetOperationListStatusFunc();
	// }, []);

	// useEffect(() => {
	//   if (login.isAvailable) {
	//     <Route
	//           exact
	//           path="/index/main-dashboard"
	//           render={() =><MainDashboard /> }
	//         />
	//     // history.push({
	//     //   pathname: "/index/dashboard",
	//     // });
	//   }
	// }, [login]);

	const handleService = (s, a) => {
		// history.push("account-management");
		setservice(s);
		setservicename(a);

		seta(true);
	};

	useEffect(() => {
		dispatch(getSidebar(r));
	}, []);

	// useEffect(() => {
	// 	dispatch(
	// 		getModulesForPartner(
	// 			{
	// 				authentication: {
	// 					partnerId: 1,
	// 					sKey: "OZa6b6SNays37d+UVaWnfqJsuHI5W+i4SawctRtwy4A=",
	// 				},
	// 			},
	// 			authToken,
	// 			history
	// 		)
	// 	);

	// }, [partnerloginUser.data.AuthToken]);

	if (a) {
		return <Content service={service} servicename={servicename} />;
	}

	return (
		<>
			<div className="main-container">
				<Grid container className="main-container">
					<Grid item xs={1}></Grid>

					<Grid item xs={10} style={{ marginTop: "6rem" }}>
						{ }
						{<div className="service-cards-wrapper">
							{" "}

							{login.data.Role.toLowerCase() === "owner" && getMappedListRes.success &&
								adminArr.map((s, id) =>
									getMappedListRes.data.moduleAllocationVO && getMappedListRes.data.moduleAllocationVO.masterModuleMappingList && getMappedListRes.data.moduleAllocationVO.masterModuleMappingList.includes(s.flag) && (
										<Col
											xs={12}
											sm={6}
											md={4}
											lg={3}
											key={id}
											onClick={() => handleService(s.service, s.name)}
										>
											<Card className="card-stats">
												<CardBody>
													<Row>
														<Col xs={5} md={4}>
															<img
																src={`${process.env.PUBLIC_URL}/${Theme}/${s.logoName}.png`}
																alt={s.icon}
																style={{ width: "75px" }}
															/>
														</Col>
													</Row>
													<Row>
														<Col xs={12} md={12}>
															<div style={{ fontSize: "17px" }}>
																<CardTitle tag="p" style={{ margin: "0" }}>
																	{s.name}
																</CardTitle>
															</div>
														</Col>
													</Row>
												</CardBody>
												<CardFooter>
													<hr style={{ marginBottom: "0px" }} />
													<div style={{ padding: "10px 0px" }}>
														<span
															style={{ fontSize: "13px" }}
															className="cust-card-footer-title"
														>
															{s.description}
														</span>
													</div>
												</CardFooter>
											</Card>
										</Col>
									)
								)}


							{console.log("ress", getMapArrAdmin)}
							{/* {login.data.Role.toLowerCase() === "admin" && getMappedListForAdminRes.success &&

								getMapArrAdmin.map((s, id) =>
									getMappedListForAdminRes.data.moduleAllocationVO && getMappedListForAdminRes.data.moduleAllocationVO.masterModuleMappingList && getMappedListForAdminRes.data.moduleAllocationVO.masterModuleMappingList.includes(s.flag) &&
									(
										<Col
											xs={12}
											sm={6}
											md={4}
											lg={3}
											key={id}
											onClick={() => handleService(s.service, s.name)}
										>
											<Card className="card-stats">
												<CardBody>
													<Row>
														<Col xs={5} md={4}>
															<img
																src={`${process.env.PUBLIC_URL}/${Theme}/${s.logoName}.png`}
																alt={s.icon}
																style={{ width: "75px" }}
															/>
														</Col>
													</Row>
													<Row>
														<Col xs={12} md={12}>
															<div style={{ fontSize: "17px" }}>
																<CardTitle tag="p" style={{ margin: "0" }}>
																	{s.name}
																</CardTitle>
															</div>
														</Col>
													</Row>
												</CardBody>
												<CardFooter>
													<hr style={{ marginBottom: "0px" }} />
													<div style={{ padding: "10px 0px" }}>
														<span
															style={{ fontSize: "13px" }}
															className="cust-card-footer-title"
														>
															{s.description}
														</span>
													</div>
												</CardFooter>
											</Card>
										</Col>
									))}  */}




							{/* {filteredServices.map((s, id) => (
								<Col
									xs={12}
									sm={6}
									md={4}
									lg={3}
									key={id}
									onClick={() => handleService(s.service, s.name)}
								>
									<Card className="card-stats">
										<CardBody>
											<Row>
												<Col xs={5} md={4}>
													<img
														src={`${process.env.PUBLIC_URL}/${Theme}/${s.logoName}.png`}
														alt={s.icon}
														style={{ width: "75px" }}
													/>
												</Col>
											</Row>
											<Row>
												<Col xs={12} md={12}>
													<div style={{ fontSize: "17px" }}>
														<CardTitle tag="p" style={{ margin: "0" }}>
															{s.name}
														</CardTitle>
													</div>
												</Col>
											</Row>
										</CardBody>
										<CardFooter>
											<hr style={{ marginBottom: "0px" }} />
											<div style={{ padding: "10px 0px" }}>
												<span
													style={{ fontSize: "13px" }}
													className="cust-card-footer-title"
												>
													{s.description}
												</span>
											</div>
										</CardFooter>
									</Card>
								</Col>
							))} */}

							{login.data.Role.toLowerCase() === "admin" &&
								filteredServices.map((s, id) => (
									<Col
										xs={12}
										sm={6}
										md={4}
										lg={3}
										key={id}
										onClick={() => handleService(s.service, s.name)}
									>
										<Card className="card-stats">
											<CardBody>
												<Row>
													<Col xs={5} md={4}>
														<img
															src={`${process.env.PUBLIC_URL}/${Theme}/${s.logoName}.png`}
															alt={s.icon}
															style={{ width: "75px" }}
														/>
													</Col>
												</Row>
												<Row>
													<Col xs={12} md={12}>
														<div style={{ fontSize: "17px" }}>
															<CardTitle tag="p" style={{ margin: "0" }}>
																{s.name}
															</CardTitle>
														</div>
													</Col>
												</Row>
											</CardBody>
											<CardFooter>
												<hr style={{ marginBottom: "0px" }} />
												<div style={{ padding: "10px 0px" }}>
													<span
														style={{ fontSize: "13px" }}
														className="cust-card-footer-title"
													>
														{s.description}
													</span>
												</div>
											</CardFooter>
										</Card>
									</Col>
								))
							}

							{/* {login.data.Role.toLowerCase() === "admin" &&
								supAdminArr.map((s, id) => (
									<Col
										xs={12}
										sm={6}
										md={4}
										lg={3}
										key={id}
										onClick={() => handleService(s.service, s.name)}
									>
										<Card className="card-stats">
											<CardBody>
												<Row>
													<Col xs={5} md={4}>
														<img
															src={`${process.env.PUBLIC_URL}/${Theme}/${s.logoName}.png`}
															alt={s.icon}
															style={{ width: "75px" }}
														/>
													</Col>
												</Row>
												<Row>
													<Col xs={12} md={12}>
														<div style={{ fontSize: "17px" }}>
															<CardTitle tag="p" style={{ margin: "0" }}>
																{s.name}
															</CardTitle>
														</div>
													</Col>
												</Row>
											</CardBody>
											<CardFooter>
												<hr style={{ marginBottom: "0px" }} />
												<div style={{ padding: "10px 0px" }}>
													<span
														style={{ fontSize: "13px" }}
														className="cust-card-footer-title"
													>
														{s.description}
													</span>
												</div>
											</CardFooter>
										</Card>
									</Col>
								))} */}




							{/* {login.data.Role.toLowerCase() === "dealer" &&
								dealer.map((s, id) => (
									<Col
										xs={12}
										sm={6}
										md={4}
										lg={3}
										key={id}
										onClick={() => handleService(s.service, s.name)}
									>
										<Card className="card-stats">
											<CardBody>
												<Row>
													<Col xs={5} md={4}>
														<img
															src={`${process.env.PUBLIC_URL}/${Theme}/${s.logoName}.png`}
															alt={s.icon}
															style={{ width: "75px" }}
														/>
													</Col>
												</Row>
												<Row>
													<Col xs={12} md={12}>
														<div style={{ fontSize: "17px" }}>
															<CardTitle tag="p" style={{ margin: "0" }}>
																{s.name}
															</CardTitle>
														</div>
													</Col>
												</Row>
											</CardBody>
											<CardFooter>
												<hr style={{ marginBottom: "0px" }} />
												<div style={{ padding: "10px 0px" }}>
													<span
														style={{ fontSize: "13px" }}
														className="cust-card-footer-title"
													>
														{s.description}
													</span>
												</div>
											</CardFooter>
										</Card>
									</Col>
								))}

							{login.data.Role.toLowerCase() === "bank" &&
								bank.map((s, id) => (
									<Col
										xs={12}
										sm={6}
										md={4}
										lg={3}
										key={id}
										onClick={() => handleService(s.service, s.name)}
									>
										<Card className="card-stats">
											<CardBody>
												<Row>
													<Col xs={5} md={4}>
														<img
															src={`${process.env.PUBLIC_URL}/${Theme}/${s.logoName}.png`}
															alt={s.icon}
															style={{ width: "75px" }}
														/>
													</Col>
												</Row>
												<Row>
													<Col xs={12} md={12}>
														<div style={{ fontSize: "17px" }}>
															<CardTitle tag="p" style={{ margin: "0" }}>
																{s.name}
															</CardTitle>
														</div>
													</Col>
												</Row>
											</CardBody>
											<CardFooter>
												<hr style={{ marginBottom: "0px" }} />
												<div style={{ padding: "10px 0px" }}>
													<span
														style={{ fontSize: "13px" }}
														className="cust-card-footer-title"
													>
														{s.description}
													</span>
												</div>
											</CardFooter>
										</Card>
									</Col>
								))} */}


						</div>}
					</Grid>

					<Grid item xs={1}></Grid>
				</Grid>
			</div>
		</>
	);
}

export default MainDashboard;
